import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input, Checkbox } from 'antd'
import css from '../Users.css'
import formCss from '../../../common/Form.css'

const EditUserModalForm = ({
  confirmPassword,
  dso,
  email,
  isTopsAdmin,
  locations,
  onAddLocation,
  onInputChange,
  password,
  userLocations,
  userType,
  userTypes,
}) => (
  <Form layout="horizontal" className={css.modalForm}>
    <div className="ant-checkbox-modifier">
      {/*
         antd is a giant pain in the neck, you have to wrap it in a class
         to update antd styles. The way that we load our styles in with CSS
         Modules we preface and suffix our styles to prevent overlap. Sadly
         this nullifies the ability to wrap our antd components, so we're left
         with this hacky garbage, should the way to fix this come about. PLZ DO!
        */}
      <style>
        {`.ant-checkbox-modifier .ant-checkbox-wrapper {
              margin-left: 0;
              margin-right: 8px;
            }`}
      </style>
      {dso && (
        <Form.Item label="User Type" type="text" className={formCss.input}>
          {userTypes(userType).map(type => (
            <Checkbox
              key={type.label}
              checked={type.checked}
              name="userType"
              onChange={onInputChange}
              value={type.value}
            >
              {type.label}
            </Checkbox>
          ))}
        </Form.Item>
      )}
      {userType === 'location_admin' && (
        <Form.Item label="User Location" type="text" className={formCss.input}>
          {locations.map(location => (
            <Checkbox
              key={location.name}
              checked={userLocations.includes(location.id)}
              name="userLocations"
              onChange={onAddLocation}
              value={location.id}
            >
              {location.name}
            </Checkbox>
          ))}
        </Form.Item>
      )}
    </div>
    <Form.Item label="E-mail" type="email" className={formCss.input}>
      <Input value={email} name="email" onChange={onInputChange} />
    </Form.Item>
    {isTopsAdmin && (
      <React.Fragment>
        <Form.Item
          label="New Password"
          type="password"
          className={formCss.input}
        >
          <Input
            type="password"
            value={password}
            name="password"
            onChange={onInputChange}
          />
        </Form.Item>
        <Form.Item
          label="Confirm Password"
          type="password"
          className={formCss.input}
        >
          <Input
            type="password"
            value={confirmPassword}
            name="confirmPassword"
            onChange={onInputChange}
          />
        </Form.Item>
      </React.Fragment>
    )}
  </Form>
)

EditUserModalForm.propTypes = {
  confirmPassword: PropTypes.string.isRequired,
  dso: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired,
  isTopsAdmin: PropTypes.bool.isRequired,
  locations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })).isRequired,
  onAddLocation: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  password: PropTypes.string.isRequired,
  userLocations: PropTypes.arrayOf(PropTypes.string),
  userType: PropTypes.string.isRequired,
  userTypes: PropTypes.func.isRequired,
}

EditUserModalForm.defaultProps = {
  userLocations: [],
}

export default EditUserModalForm



// WEBPACK FOOTER //
// ./src/AddPractice/Users/EditUserModal/EditUserModalForm.js